import React, { useCallback, useEffect, useState } from "react";
import "./WalletTransactionDetails.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { Link, useParams } from "react-router-dom";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import axios from "axios";
// import { saveAs } from "file-saver";
import { jsPDF } from "jspdf"; // Add this import
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function WalletTransactionDetails() {
  const { userID, RendomTokenfetch, profileData } = useAuth();
  let { transactionid } = useParams();
  const [TransactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  // console.log("TransactionData", TransactionData);
  // console.log("profileData", profileData);
  const transaction = {
    name: profileData?.username || "",
    email: profileData?.email || "",
    phone: profileData?.number || "",
    address: profileData?.address || "",
    amount: TransactionData?.amount || 0,
    bank_ref_num: TransactionData?.bank_ref_num || "",
    order_id: TransactionData?.order_id || "",
    payment_date: TransactionData?.payment_date || "",
    payment_status: TransactionData?.payment_status || "",
    transactionid: TransactionData?.transactionid || "",
  };

  const FetchTransaction = useCallback(async () => {
    let fdata = new FormData();
    fdata.append("userid", userID);
    fdata.append("order_id", transactionid);
    setLoading(true);
    try {
      await axios
        .post(`${WebsiteAPIurl}wallet_transacton_details`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setTransactionData(response.data.WalletTransactionData);
          }
          if (response.data.status === "0") {
            setTransactionData([]);
            NotifyMessageNoReload(response.data.message, "danger");
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, transactionid, userID]);

  useEffect(() => {
    FetchTransaction();
  }, [FetchTransaction]);

  const handleDownloadReceipt = () => {
    // Create a new PDF document
    const doc = new jsPDF();

    // Add company logo or headerf
    doc.setFontSize(20);
    doc.setTextColor(40, 40, 40);
    doc.text("Payment Receipt", 105, 20, { align: "center" });

    // Add divider line
    doc.setDrawColor(200, 200, 200);
    doc.line(20, 25, 190, 25);

    // Add transaction details
    doc.setFontSize(12);
    doc.text(`Transaction ID: ${transaction.transactionid}`, 20, 35);
    doc.text(`Date: ${transaction.payment_date}`, 20, 45);

    // Add personal information
    doc.text(`Name: ${transaction.name}`, 20, 60);
    doc.text(`Email: ${transaction.email}`, 20, 70);
    doc.text(`Phone: ${transaction.phone}`, 20, 80);
    doc.text(`Address: ${transaction.address}`, 20, 90);

    // Add transaction details
    doc.text(`Order ID : ${transaction.order_id}`, 20, 120);

    // Add amount with color based on value
    const amountText = `Amount: ${transaction.amount < 0 ? "-" : ""} ${Math.abs(
      transaction.amount
    ).toFixed(2)} `;
    doc.setTextColor(
      transaction.amount < 0 ? 244 : 76,
      transaction.amount < 0 ? 67 : 175,
      transaction.amount < 0 ? 54 : 80
    );
    doc.text(amountText, 20, 130);

    // Reset text color
    doc.setTextColor(40, 40, 40);

    // Add status
    doc.text(`Status: ${transaction.payment_status}`, 20, 140);

    // Add footer
    doc.setFontSize(10);
    doc.setTextColor(150, 150, 150);
    doc.text("Thank you for your payment!", 105, 180, { align: "center" });
    doc.text("This is an automated receipt. No signature required.", 105, 185, {
      align: "center",
    });

    // Save the PDF
    doc.save(`Receipt_${transaction.order_id}.pdf`);
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Passbook", pagelink: "passbook" },
            { name: "Wallet Transactions", pagelink: "wallet-transactions" },
            { name: "Wallet Transaction Details" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer walletDetails">
            <div
              className="newspapermultyupdatebox"
              style={{ borderBottom: "unset" }}
            >
              <div className="row my-1">
                <div className="col-lg-12 col-md-12  mt-1">
                  <Link
                    to="/wallet-transactions"
                    className="DefaultHoverbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-arrow-left me-2"></i>
                    </span>{" "}
                    Back
                  </Link>
                </div>
              </div>
            </div>

            <div className="transaction_header p-4 mb-4 border border-success">
              <div className="d-flex align-items-center justify-content-between">
                <div className="">
                  <h4 className="mb-1 text-light fw-600">Wallet Add</h4>
                  <p className="mb-0 text-light">
                    Completed on {transaction.payment_date}
                  </p>
                </div>
                <div className="text-md-end">
                  <h3 className="text-light mb-0">₹{transaction.amount}</h3>
                  <span
                    className={`badge ${
                      transaction.payment_status === "1"
                        ? "bg-success"
                        : "bg-danger"
                    }`}
                  >
                    {transaction.payment_status === "1" ? "Success" : "Faild"}
                  </span>
                </div>
              </div>
            </div>
            <div className="payment-container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  {/* <div className="divider"></div> */}

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-info-circle me-2"></i>Transaction
                      Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        <tr>
                          <td className="label">Order ID</td>
                          <td>{transaction.order_id}</td>
                        </tr>
                        <tr>
                          <td className="label">Transaction ID</td>
                          <td>{transaction.transactionid}</td>
                        </tr>
                        <tr>
                          <td className="label">Payment Date</td>
                          <td>{transaction.payment_date}</td>
                        </tr>
                        <tr>
                          <td className="label">Amount</td>
                          <td>
                            <span
                              className="badge bg-primary "
                              style={{ fontSize: "16px" }}
                            >
                              ₹{transaction.amount}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="label">Paid Status</td>
                          <td>
                            <span
                              className={`badge ${
                                transaction.payment_status === "1"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {transaction.payment_status === "1"
                                ? "Success"
                                : "Faild"}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="divider"></div>

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-user me-2"></i>User Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        <tr>
                          <td className="label">User Name</td>
                          <td>{transaction.name}</td>
                        </tr>
                        <tr>
                          <td className="label">Mobile Number</td>
                          <td>{transaction.phone}</td>
                        </tr>
                        <tr>
                          <td className="label">Email Address</td>
                          <td>{transaction.email}</td>
                        </tr>
                        <tr>
                          <td className="label">Address</td>
                          <td>{transaction.address}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="divider"></div>
                <div className="col-xl-12 col-lg-12 col-md-12 text-center">
                  <div>
                    <button
                      className="theme-btn btn-style-three submitbtn"
                      style={{ marginRight: "12px" }}
                      onClick={handleDownloadReceipt}
                    >
                      <i className="fa fa-download mx-2" aria-hidden="true"></i>{" "}
                      Download Receipt
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
